export const FarmCellPostTreatment = (props) => {

    const {cellContentClasses, temperatureDisplay, humidityDisplay} = props;

    return(
        <div className={cellContentClasses}>
            <div className="cell-header">
                <div className="cell-type">Post-traitement</div>
                <div className="cell-environment">
                    <span className="cell-environment__temp"><i className="fa fa-thermometer-half" />{temperatureDisplay}°C</span>
                    <span className="cell-environment__humidity"><i className="fa fa-tint" />{humidityDisplay}%</span>
                </div>
            </div>
        </div>
    );
}
